export const MASTER_TABLECACHE_KEY = 'masterEntityTable';

export const KEY_TYPES: string[] = [
  'all',
  'pos',
  'posPublic',
  'shop',
  'prod',
  'dineq',
]
